import { DeepLink } from "src/models";
import { useApplicationContext } from "./useApplication";

export function useLinkPermissions(link?: DeepLink | null) {
  const app = useApplicationContext();

  const isGlobal = !link?.orgId;
  const isShared = !isGlobal && !link?.userId;
  const isPrivate = !isGlobal && !isShared;

  const canEdit =
    link &&
    ((isGlobal && app.isSuperAdmin) ||
      (isShared && app.isOrgAdmin) ||
      isPrivate);

  return {
    isGlobal,
    isShared,
    isPrivate,
    canEdit,
    scope: isGlobal
      ? ("global" as const)
      : isShared
      ? ("workspace" as const)
      : ("private" as const),
  };
}
